import types from 'actions/types'
import { combineReducers } from 'redux'

const timeKey = (state = 'month:0', action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_DASHBOARD_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('timeKey'))
          ? action.filters.timeKey
          : state
    default: return state
  }
}

const dateRange = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_DASHBOARD_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('startDate') && action.filters.hasOwnProperty('endDate'))
          ? {startDate: action.filters.startDate, endDate: action.filters.endDate}
          : state
    default:
      return state
  }
}

const personId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_DASHBOARD_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('personId'))
          ? action.filters.personId
          : state
    default: return state
  }
}

const companyId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_VIEW_DASHBOARD_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('companyId'))
          ? action.filters.companyId
          : state
    default:
      return state
  }
}

const draftQuotes = (state = { open: true, active: true, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_DRAFT_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.draft, value: action.data.draftValue, fetching: false })
    case types.QUOTING_TOGGLE_ACTIVE_DRAFT_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign ({}, state, { fetching: false })
    default: return state
  }
}

const quotedQuotes = (state = { open: true, active: true, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_QUOTED_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_QUOTED_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.quoted, value: action.data.quotedValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const confirmedQuotes = (state = { open: true, active: true, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_CONFIRMED_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_CONFIRMED_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.confirmed, value: action.data.confirmedValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const deliveredQuotes = (state = { open: true, active: true, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_DELIVERED_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_DELIVERED_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.delivered, value: action.data.deliveredValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const invoicedQuotes = (state = { open: true, active: true, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_INVOICED_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_INVOICED_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.invoiced, value: action.data.invoicedValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const paidQuotes = (state = { open: true, active: false, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_PAID_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_PAID_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.paid, value: action.data.paidValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const rejectedQuotes = (state = { open: true, active: false, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_REJECTED_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_REJECTED_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.rejected, value: action.data.rejectedValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const creditedQuotes = (state = { open: true, active: false, data: 0, fetching: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_CREDITED_QUOTES: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_CREDITED_QUOTES: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_QUOTE_STATS_SUCCESS: return Object.assign({}, state, { data: action.data.credited, value: action.data.creditedValue, fetching: false  })
    case types.QUOTING_LOAD_QUOTE_STATS_ATTEMPT: return Object.assign({}, state, { fetching: true })
    case types.QUOTING_LOAD_QUOTE_STATS_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const recentPanel = (state = { open: true, active: true }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_RECENT_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_RECENT_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    default: return state
  }
}

const unsentPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_UNSENT_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_UNSENT_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_UNSENT_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_UNSENT_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_UNSENT_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const unconfirmedPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_UNCONFIRMED_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_UNCONFIRMED_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_UNCONFIRMED_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_UNCONFIRMED_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_UNCONFIRMED_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const notAcceptedPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_NOT_ACCEPTED_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_NOT_ACCEPTED_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_NOT_ACCEPTED_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_NOT_ACCEPTED_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_NOT_ACCEPTED_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const expiringPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_EXPIRING_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_EXPIRING_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_EXPIRING_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_EXPIRING_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_EXPIRING_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const expiredPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_EXPIRED_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_EXPIRED_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_EXPIRED_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_EXPIRED_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_EXPIRED__QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const inProductionPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_IN_PRODUCTION_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_IN_PRODUCTION_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_IN_PRODUCTION_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_IN_PRODUCTION_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_IN_PRODUCTION_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const requiredSoonPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_REQUIRED_SOON_QUOTES_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_REQUIRED_SOON_QUOTES_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_REQUIRED_SOON_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_REQUIRED_SOON_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_REQUIRED_SOON_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const inDeliveryPanel = (state = { open: true, active: true, data: [], fetcing: false }, action) => {
  switch (action.type) {
    case types.QUOTING_TOGGLE_OPEN_IN_DELIVERY_PANEL: return Object.assign({}, state, { open: !state.open })
    case types.QUOTING_TOGGLE_ACTIVE_IN_DELIVERY_PANEL: return Object.assign({}, state, { active: !state.active })
    case types.QUOTING_LOAD_IN_DELIVERY_QUOTES_ATTEMPT: return Object.assign({}, state, { data: [], fetching: true })
    case types.QUOTING_LOAD_IN_DELIVERY_QUOTES_SUCCESS: return Object.assign({}, state, { data: action.data.result, fetching: false })
    case types.QUOTING_LOAD_IN_DELIVERY_QUOTE_FAILURE: return Object.assign({}, state, { fetching: false })
    default: return state
  }
}

const isFetchingQuotes = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_SEARCH_FOR_QUOTES_ATTEMPT: return true
    case types.QUOTING_SEARCH_FOR_QUOTES_SUCCESS: return false
    case types.QUOTING_SEARCH_FOR_QUOTES_FAILURE: return false
    default: return state
  }
}

const fetchedQuotes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_SEARCH_FOR_QUOTES_SUCCESS: return action.data.result
    default: return state
  }
}

const searchedQuotes = combineReducers({
  isFetchingQuotes,
  fetchedQuotes,
})

export default combineReducers({
  timeKey,
  personId,
  companyId,
  draftQuotes,
  quotedQuotes,
  confirmedQuotes,
  deliveredQuotes,
  invoicedQuotes,
  paidQuotes,
  rejectedQuotes,
  creditedQuotes,
  recentPanel,
  unsentPanel,
  unconfirmedPanel,
  notAcceptedPanel,
  expiringPanel,
  expiredPanel,
  inProductionPanel,
  requiredSoonPanel,
  inDeliveryPanel,
  searchedQuotes,
  dateRange,
})
